import { render, staticRenderFns } from "./offlinecourse.vue?vue&type=template&id=3f9771c1&scoped=true&"
import script from "./offlinecourse.vue?vue&type=script&lang=ts&"
export * from "./offlinecourse.vue?vue&type=script&lang=ts&"
import style0 from "./offlinecourse.vue?vue&type=style&index=0&id=3f9771c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9771c1",
  null
  
)

export default component.exports